<div class="dialogContainer">
  <div class="header">
    <h2>Line {{ entityLine.lineId }} Summary</h2>
  </div>
  @if (errorMessage) {
    <div class="errorMessage">
      {{errorMessage}}
    </div>
  }
  <div class="content">
    <div class="inputRow">
      <span class="labelSpan">
        <label>PRN:</label>
      </span>
      <textarea class="noresize inputField" rows="3" cols="80" readonly [value]="prnValue()"></textarea>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Tags:</label>
      </span>
      <label class="tagsLabel">{{ entityLine.tags }}</label>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Quantity:</label>
      </span>
      <input class="standardTextBox inputField" [readonly]="preventUpdate()" [(ngModel)]="entityLine.quantity" (ngModelChange)="onQuantityChange()"/>
    </div>
    @if (entityLine.serialNumberRequired) {
      <div class="inputRow">
        <span class="labelSpan">
          <label>SN:</label>
        </span>
        <input class="standardTextBox inputField" [readonly]="preventUpdate() || entityLine.quantity > 1" [(ngModel)]="entityLine.serialNumber" />
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="cancel()">{{ preventUpdate() ? 'Close' : 'Cancel' }}</button>
      @if (!preventUpdate()) {
        <button matButton="elevated" (click)="validateDataAndClose()">Save</button>
      }
    </span>
  </div>
</div>
